// assets/global-variant-tracker.js

document.addEventListener("DOMContentLoaded", function () {
  const variantInput = document.querySelector('form[action^="/cart"] input[name="id"]');

  function updateVariantState(id) {
    if (!window.CurrentVariant) {
      window.CurrentVariant = { id: null };
    }

    window.CurrentVariant.id = id;
    window.globalVariantId = id;

       // Fetch variant details so other scripts do not need to duplicate the request
    fetch(`/variants/${id}.js`)
      .then(res => res.json())
      .then(variant => {
        window.CurrentVariant = variant;
        window.CurrentVariant.id = id;
        // Notify other scripts (like vitals) with full variant details
        document.dispatchEvent(new CustomEvent("variant:updated", { detail: { id } }));
        document.dispatchEvent(
          new CustomEvent("globalVariantIdUpdated", {
            detail: {
              variantId: id,
              variant
            }
          })
        );
      })
      .catch(() => {
        // Fallback to dispatching id only if fetch fails
        document.dispatchEvent(new CustomEvent("variant:updated", { detail: { id } }));
        document.dispatchEvent(new CustomEvent("globalVariantIdUpdated", { detail: { variantId: id } }));
      });

    
  }
  window.updateGlobalVariant = updateVariantState;
  
  document.addEventListener("change", function (e) {
    if (e.target.name === "id") {
      updateVariantState(e.target.value);
    }
  });

  // Initial value after page load
  setTimeout(() => {
    if (variantInput && variantInput.value) {
      updateVariantState(variantInput.value);
    }
  }, 500);
});
